<template>
  <div class="card md:w-96 bg-base-100 shadow-xl h-full">
    <figure>
      <img :src="getDinosaurWorking()" alt="Shoes" />
    </figure>
    <div class="card-body">
      <h2 class="card-title justify-center">PROXIMAMENTE</h2>
      <p>
        ¡Estoy trabajando arduamente para traer novedades<!-- nuevos proyectos personales -->!
      </p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    getDinosaurWorking() {
      return require(`@/assets/images/Crocosaurus.webp`);
    },
  },
};
</script>

<style>
</style>